// extracted by mini-css-extract-plugin
module.exports = {"GroupSearch":"styles_GroupSearch__2-kpa","PlaceHolders":"styles_PlaceHolders__1QmVL"};